import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import "./NoticeCard.css";
import { Button } from '@mui/material';

export default function NoticeCard({
    title,
    startDate,
    endDate,
    description,
    buttonText,
    buttonUrl,
    backgroundColor = "#FFF",
    titleColor = "#242424",
    textColor = "#4B4B4B",
    status="active",
    hasSecondButton=false,
    buttonText2,
    buttonUrl2,
    hasThirdButton=false,
    buttonText3,
    buttonUrl3,
}) {
    const handleClick = () => {
        window.open(buttonUrl, "_blank");   
    };

    const isClosed = status === "expired";

    return (
        <Card
            sx={{
                maxWidth: 360,
                backgroundColor: backgroundColor,
                borderRadius: 4,
                color: textColor,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                borderColor:'#E5E5E5',
            }}
        >
            <CardContent
                sx={{
                    padding: "16px",
                }}
            >
                <div className='statusContainer'>
                    <div className={`status ${status}`}>
                        {status === "open" ? "Aberto" : "Encerrado"}
                    </div>

                </div>
                <Typography
                    gutterBottom
                    variant="h2"
                    component="div"
                    sx={{
                        textAlign: "left",
                        fontWeight: 600,
                        fontSize: 20,
                        marginBottom: "16px",
                        color: titleColor,
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    gutterBottom
                    variant="p"
                    component="div"
                    sx={{
                        textAlign: "left",
                        fontWeight: 400,
                        fontSize: 14,
                        marginBottom: "16px",
                        color: textColor,
                    }}
                >
                    {description}
                </Typography>
                <Typography
                    variant="p"
                    sx={{
                        color: textColor,
                        display: "flex",
                        alignItems: "center",
                        textAlign: "left",
                        marginBottom: "8px",
                        fontWeight: 400,
                        fontSize: 14,
                        gap: '4px'
                    }}
                >
                    <CalendarTodayIcon style={{width: 20, height: 20}} color={textColor} />
                    Publicado em: {startDate}
                </Typography>
                <Typography
                    variant="p"
                    sx={{
                        color: textColor,
                        display: "flex",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 400,
                        fontSize: 14,
                        gap: '4px'
                    }}
                >
                    <AccessAlarmIcon style={{width: 20, height: 20}}  color={textColor} />
                    Encerra em: {endDate}
                </Typography>
            </CardContent>
            <CardActions
                sx={{
                    padding: "0 16px 16px 16px",
                }}
                className={`noticeCardActions ${((hasSecondButton && !hasThirdButton) || (!hasSecondButton && hasThirdButton)) ? "noticeCardActions--two" : ""}`}
            >
                <Button className='buttonAction' variant="contained" endIcon={isClosed ? null : <ChevronRightIcon />} onClick={handleClick} disabled={isClosed}>
                    {isClosed ? "Inscrições encerradas" : buttonText}
                </Button>

                {hasSecondButton && (
                    <Button className='buttonAction buttonActionOutlined' variant="outlined" endIcon={<ChevronRightIcon />} onClick={() => window.open(buttonUrl2, "_blank")} disabled={isClosed}>
                        {buttonText2}
                    </Button>
                )}

                {hasThirdButton && (
                    <Button className='buttonAction buttonActionOutlined' variant="outlined" endIcon={<ChevronRightIcon />} onClick={() => window.open(buttonUrl3, "_blank")} disabled={!buttonUrl3}>
                        {buttonText3}
                    </Button>
                )}

            </CardActions>
        </Card>
    );
}
